// extracted by mini-css-extract-plugin
export default {"cardFrontContainer":"FrontCard_cardFrontContainer__05NhB","cardFront":"FrontCard_cardFront__0Zitw","vote":"FrontCard_vote__8hW8a","voteValue":"FrontCard_voteValue__kzM6F"};